/* eslint-disable no-lone-blocks */
import React, { Component } from "react";

class GuideManagers extends Component {
  state = {
    nodes: [],
  };

  componentDidMount = () => {
    this.buildNodes();
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      prevProps.data !== this.props.data ||
      prevProps.isOtosanContact !== this.props.isOtosanContact
    ) {
      // top level maangers
      this.buildNodes();
    }
  };

  componentWillUnmount = () => {
    // this.setState({ nodes: null });
  };

  buildNodes = () => {
    let nodes = [];
    this.props.data
      .filter((e) => {
        return (
          e.reportManager === null &&
          e.isOtosanContact === this.props.isOtosanContact
        );
      })
      .forEach((tlm) => {
        let node = {
          id: tlm.id,
          name: tlm.fullname,
          managerId: null,
          department: tlm.department,
          position: tlm.position,
          nodes: this.getNodes(this.getReporters(this.props.data, tlm.id)),
        };
        nodes.push(node);
      });

    const sorted = nodes.sort((a, b) => {
      return a.name - b.name;
    });

    this.setState({ nodes: sorted });
  };

  subMenuToggle = (event) => {
    // console.dir(event.target);
    // Only watch clicks on .toggle-switch
    if (!event.target.classList.contains("toggle-switch")) {
      return;
    }

    // Prevent the actual click on the link

    // Toggle .is-active on parent <li> element
    const subNodes = event.target.parentNode.parentNode.querySelectorAll(
      ":scope > ul"
    );
    const className = "is-active";

    subNodes.forEach((p) => p.classList.toggle(className));

    event.target.parentNode.children[0].classList.toggle("minus");
    event.target.parentNode.classList.toggle("active");

    // Only open the next direct ul
    // parent.querySelectorAll(":scope > ul").forEach((element) => {
    //   element.classList.toggle(className);
    // });

    event.stopPropagation();
  };

  handleSelectManager = (e, mgrId) => {
    // console.dir(e.target);
    this.props.onSelectManager(mgrId);
    this.subMenuToggle(e);
    e.stopPropagation();
  };

  getReporters = (data, mgrId) => {
    let reporters = data
      .filter((e) => e.reportManager !== null)
      .filter((e) => e.reportManager.id === mgrId);

    return reporters;
  };

  getNodes = (reporters) => {
    let nodes = [];
    reporters.forEach((e) => {
      let node = {
        id: e.id,
        name: e.fullname,
        managerId: e.reportManager ? e.reportManager.id : null,
        department: e.department,
        position: e.position,
        nodes: this.getNodes(this.getReporters(this.props.data, e.id)),
      };

      nodes.push(node);
    });
    return nodes;
  };

  renderNodeIcon = (n) => {
    if (!n.nodes) return null;
    let hasGrandChildren = false;
    n.nodes.forEach((ch) => {
      if (ch.nodes.length > 0) {
        hasGrandChildren = true;
      }
    });

    if (hasGrandChildren) {
      return (
        <span
          onClick={this.subMenuToggle}
          className="toggle-switch iconmford fo-icon-add"
        ></span>
      );
    } else {
      return (
        <span
          className="toggle-switch iconmford fo-icon-remove"
          style={{ paddingRight: "5px" }}
        ></span>
      );
    }
  };

  renderNodes = (nodes) => {
    let fNodes = nodes.map((n) => {
      if (n.nodes.length === 0) {
        return null;
      }

      let classList = "nav-dropdown-two";
      if (n.managerId === null) {
        classList = "leftsidequide";
      }

      return (
        <ul
          key={n.id}
          className={classList}
          onClick={(e) => this.handleSelectManager(e, n.id)}
        // data={n.id}
        >
          <li>
            <div className="quideLinkArea" style={{ lineHeight: "30px" }}>
              {this.renderNodeIcon(n)}
              <span className="toggle-switch guideTitle" style={{ display: "flex", flexDirection: "column" }}>
                <span className="titleGuidColor hide">{n.department}</span>
                <span>{n.name}</span>
                <span style={{ fontSize: "10px", textAlign: "left", border: "none" }}>{n.position}</span>

              </span>
            </div>
            {n.nodes.length > 0 ? this.renderNodes(n.nodes) : null}
          </li>
        </ul>
      );
    });

    return fNodes;
  };

  render() {
    if (!this.state.nodes) {
      return null;
    }

    // console.log(this.state.nodes);

    return (
      <div className="row mb-4">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className="leftsidequideArea">
            {this.renderNodes(this.state.nodes)}
          </div>
        </div>
      </div>
    );
  }
}

export default GuideManagers;
